import React from 'react';
import { CssVariableType, VariableComponent, CssVariable } from '../../../types';
import { TextTransformInput } from '../../UI/Input/TransformInput';
import { ColorInput } from '../../UI/Input/ColorInput';
import { SizeInput } from '../../UI/Input/SizeInput';
import { useStyleContext } from '../../../context/StyleContext';
import { BoxShadowInput } from '../../UI/Input/BoxShadowInput';
import { useLocation } from 'react-router';
import ResetButtonWrapper from '../../UI/ResetButtonWrapper';
import { FontInput } from '../../UI/Input/FontInput';

interface VariableInputBuilderProps {
  variable: CssVariable;
}

// sorry in a hurry
// improve this logic please @justin
export const useAppComponent = () => {
  const location = useLocation();

  if (location.pathname.includes('viz')) {
    return VariableComponent.Viz;
  }

  if (location.pathname.includes('liveboard')) {
    return VariableComponent.Liveboard;
  }

  if (location.pathname.includes('spotter')) {
    return VariableComponent.Spotter;
  }

  if (location.pathname.includes('search')) {
    return VariableComponent.Search;
  }

  if (location.pathname.includes('home')) {
    return VariableComponent.App;
  }

  return VariableComponent.Default;
};

const getInfo = (variable: CssVariable) => {
  return `${variable.key}`;
};

const VariableInput: React.FC<VariableInputBuilderProps> = (props) => {
  const { updateVariable, styleState } = useStyleContext();

  // Add null checks
  if (!props.variable || !props.variable.key) {
    return null;
  }

  const updateVariableValue = (value) => {
    updateVariable(props.variable.key, value);
  };
  const component = useAppComponent();
  const curValue = styleState[props.variable.key] || '';
  if (props.variable.components && !props.variable.components.includes(component)) {
    return null;
  }

  if (props.variable.hidden) {
    return null;
  }

  switch (props.variable.type) {
    case CssVariableType.Color: {
      return (
        <ResetButtonWrapper
          updateVariableValue={updateVariableValue}
          variableName={props.variable.name}
        >
          <ColorInput
            name={props.variable.name}
            value={curValue}
            onChange={updateVariableValue}
            info={getInfo(props.variable)}
          />
        </ResetButtonWrapper>
      );
    }
    case CssVariableType.TextTransform: {
      return (
        <ResetButtonWrapper
          updateVariableValue={updateVariableValue}
          variableName={props.variable.name}
        >
          <TextTransformInput
            name={props.variable.name}
            onChange={updateVariableValue}
            value={curValue}
            info={getInfo(props.variable)}
          />
        </ResetButtonWrapper>
      );
    }
    case CssVariableType.Size: {
      return (
        <ResetButtonWrapper
          updateVariableValue={updateVariableValue}
          variableName={props.variable.name}
        >
          <SizeInput
            name={props.variable.name}
            onChange={updateVariableValue}
            value={curValue}
            info={props.variable.key}
            range={{ min: 0, max: 1000 }}
          />
        </ResetButtonWrapper>
      );
    }
    case CssVariableType.BoxShadow: {
      return (
        <BoxShadowInput
          name={props.variable.name}
          onChange={updateVariableValue}
          value={curValue}
          info={getInfo(props.variable)}
        />
      );
    }
    case CssVariableType.Font: {
      return (
        <ResetButtonWrapper
          updateVariableValue={updateVariableValue}
          variableName={props.variable.name}
        >
          <FontInput
            name={props.variable.name}
            onChange={updateVariableValue}
            value={{ value: curValue, label: curValue }}
            info={getInfo(props.variable)}
          />
        </ResetButtonWrapper>
      );
    }
    // case CssVariableType.Font: {
    //   return (
    //     <ResetButtonWrapper
    //       updateVariableValue={updateVariableValue}
    //       variableName={props.variable.name}
    //     >
    //       <FontInput
    //         name={props.variable.name}
    //         onChange={updateVariableValue}
    //         value={{ value: curValue, label: curValue }}
    //         info={getInfo(props.variable)}
    //       />

    //     </ResetButtonWrapper>
    //   );
    // }

    default: {
      return null;
    }
  }
};

const MemoizedVariableInputBuilder = React.memo(VariableInput);
export { MemoizedVariableInputBuilder as VariableInput };
